import { TopThreatsView } from '../view/TopThreatsView';
import { templateTopThreats } from '../view/template';
import { TopThreatsWebComponent } from '..';
import { BaseWidgetController } from '../../widget/BaseWidgetController';
import { GetTopThreatsBlockedResponse } from '@nirvana/shared/dtos/types/widgets/common';

export class TopThreatsController extends BaseWidgetController<GetTopThreatsBlockedResponse> {
  public component: TopThreatsWebComponent;
  public view: TopThreatsView;
  public viewConstructor: typeof TopThreatsView;

  constructor(component: TopThreatsWebComponent) {
    super(component);
    this.initialWidgetSetup({
      viewConstructor: TopThreatsView,
      viewTemplate: templateTopThreats,
      dataFetchMethod: this.component.dependencies.api.clients.Widgets.getTopThreatsBlocked,
    });
  }
}
